const sizes = {
  gap: '2rem',
  padding: '1rem 2.4rem',
  width: {
    sm: '48rem',
  },
};

export const lightTheme = {
  sizes,
  colors: {
    background: '#FFFFFFBB',
    text: '#0D0D0D',
    border: '#FFFFFF77',
    actions: {
      active: '#00000077',
      hover: '#00000011',
    },
  },
};

export const darkTheme = {
  sizes,
  colors: {
    background: '#111111',
    text: '#FFFFFFBB',
    border: '#FFFFFF77',
    actions: {
      active: '#00000033',
      hover: '#1c1c1c',
    },
  },
};
